import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TopBar } from '$lib/components/shell/TopBar';
import { NavRail } from '$lib/components/shell/NavRail';
import { StatusBar } from '$lib/components/shell/StatusBar';
import { AuthGate } from '$lib/components/shell/AuthGate';

// Three-pane shell: top bar / nav rail + center / status bar.
// The right context panel (decision 9) is opt-in per route — it's owned
// by individual views (unit detail, map polygon area-analysis), not the shell.
export function RootLayout() {
  const { t } = useTranslation();
  return (
    <AuthGate>
      <div className="flex h-screen flex-col bg-bg text-fg">
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-50 focus:rounded-sm focus:bg-accent focus:px-3 focus:py-1 focus:text-xs focus:text-accent-fg focus:shadow-elev-3"
        >
          {t('common.skipToContent')}
        </a>
        <TopBar />
        <div className="flex min-h-0 flex-1">
          <NavRail />
          <main
            id="main-content"
            tabIndex={-1}
            className="flex min-w-0 flex-1 flex-col overflow-hidden bg-bg outline-none"
          >
            <Outlet />
          </main>
        </div>
        <StatusBar />
      </div>
    </AuthGate>
  );
}
